import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor } from 'thunderbolt-viewer-manager-types'
import { name } from './symbols'
import { EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ViewerManagerQueryApiEditorConfig } from './types'

const viewerManagerQueryApiFactory = (
	viewerManagerQueryApiConfig: ViewerManagerQueryApiEditorConfig
): IViewerManagerImplementor<'query'> => {
	const { searchParams } = new URL(viewerManagerQueryApiConfig.url)
	return {
		query: {
			isQaMode() {
				return viewerManagerQueryApiConfig.isQaMode
			},
			getQueryParam(paramName) {
				return searchParams.get(paramName) || undefined
			},
		},
	}
}
export const ViewerManagerQueryApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name)],
	viewerManagerQueryApiFactory
)
